import { AUTH_PATH } from "./types.js";
export const buildUrl = ({
  host,
  authType,
  inputType,
  tokenOutputType,
  refreshTokenOutputType
}) => {
  const url = new URL(`https://${host}/${AUTH_PATH[authType]}`);
  const queryParams = {
    jo: tokenOutputType,
    rto: refreshTokenOutputType
  };
  if (inputType) {
    queryParams.i = inputType;
  }
  let key;
  for (key in queryParams) {
    const value = queryParams[key];
    if (value !== undefined) {
      url.searchParams.append(key, value);
    }
  }
  return url.href;
};
//# sourceMappingURL=utils.js.map